import { UNSET_PROPERTY_KEY } from '@blaze-shared/elements-domain';
import { deepClone, deepmergeExceptArrays, isEmptyish } from '@blaze-shared/shared-util';
import { removeByMarker } from '@blaze-shared/workflow-domain';

import { ALL_OVERRIDE_TARGETS, type PropsOverrides } from './models';

export function mergeElementAndStyleProps(
  elementProps: any,
  elementOverrides: PropsOverrides | undefined,
  styleProps: any,
  styleOverrides: PropsOverrides | undefined,
): { props: any; overrides?: PropsOverrides } {
  const mergedProps = deepClone(deepmergeExceptArrays(styleProps ?? {}, elementProps ?? {}));

  let mergedOverrides: PropsOverrides | undefined;
  for (const target of ALL_OVERRIDE_TARGETS) {
    const styleTargetPropsOverrides = deepClone(styleOverrides?.[target]?.props ?? {});
    const elementTargetPropsOverrides = deepClone(elementOverrides?.[target]?.props ?? {});

    if (isEmptyish(styleTargetPropsOverrides) && isEmptyish(elementTargetPropsOverrides)) {
      continue;
    }

    removeByMarker(
      elementTargetPropsOverrides,
      [elementTargetPropsOverrides, styleTargetPropsOverrides],
      UNSET_PROPERTY_KEY,
      true,
    );

    mergedOverrides ??= {};
    mergedOverrides[target] = {
      props: deepmergeExceptArrays(styleTargetPropsOverrides, elementTargetPropsOverrides),
    };
  }

  return { props: mergedProps, overrides: mergedOverrides };
}
